import { RuleResult } from 'types/DeclarationP5'

const C0586Validator = {
  validateCountryOfRoutingRequirement: ({
    security,
    bindingItinerary,
  }: {
    security: string
    bindingItinerary: string
  }): RuleResult => {
    if (bindingItinerary === 'true') {
      return 'REQUIRED'
    }
    if (security === '1' || security === '2' || security === '3') {
      return 'REQUIRED'
    }

    return 'OPTIONAL'
  },
} as const

export default C0586Validator
